module.exports = __webpack_public_path__ + "static/00007.ed6bd622.jpg";